import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'
import { Address } from 'viem'
import { EAddToPositionDialogContent } from './EAddToPositionDialogContent'

export interface EAddToPositionDialogProps extends CommonDialogProps {
  /** Sub-account ID to add to */
  subAccountId: number
  /** Controller (liability vault) if position has debt - used to filter compatible collaterals */
  controller?: Address | null
  /** Current debt in USD (for health factor display) */
  currentDebtUSD: number
  /** Current LTV percentage */
  currentLTV: number
  /** Liquidation LTV percentage (for health factor calculation) */
  liquidationLTV: number
  /** Pre-select a specific collateral vault in the dropdown */
  initialVaultAddress?: Address
}

function EAddToPositionDialogContainer(
  props: Omit<EAddToPositionDialogProps, 'open' | 'setOpen'> & { closeDialog: () => void },
) {
  return <EAddToPositionDialogContent {...props} />
}

const EAddToPositionDialogContainerWithSuspense = withSuspense(EAddToPositionDialogContainer, DialogContentSkeleton)

function EAddToPositionDialog({ open, setOpen, ...props }: EAddToPositionDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <EAddToPositionDialogContainerWithSuspense closeDialog={() => setOpen(false)} {...props} />
      </DialogContent>
    </Dialog>
  )
}

export const eAddToPositionDialogConfig: DialogConfig<EAddToPositionDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: EAddToPositionDialog,
}
